import {inlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
export class CreateLastCallUseCase extends UseCase {
  constructor({createLastCallService, fromRawParamToCreateLastCallRequestValueObjectMapper}) {
    super()
    this._createLastCallService = createLastCallService
    this._fromRawParamToCreateLastCallRequestValueObjectMapper = fromRawParamToCreateLastCallRequestValueObjectMapper
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'CreateLastCallUseCase#execute'})
  @inlineError
  async execute({adId, dealerId, makeId, title, uniqueVehicleId, postalCode, userId}) {
    const createLastCallRequestVO = this._fromRawParamToCreateLastCallRequestValueObjectMapper.map({
      adId,
      dealerId,
      makeId,
      postalCode,
      title,
      uniqueVehicleId,
      userId
    })
    const [createLastCallError, createLastCallResponseVO] = await this._createLastCallService.execute({
      createLastCallRequestVO
    })

    if (createLastCallError) return Promise.reject(createLastCallError)

    return Promise.resolve(createLastCallResponseVO.toJSON())
  }
}
